import type { Day } from 'date-fns';

import { CountryCodeAlpha3 } from 'common/api/api-types';

export const mapbox = {
  style: {
    light: 'mapbox://styles/woltmap/ckhd5divh05ar19mri51kjnfc',
    dark: 'mapbox://styles/woltmap/ckf6hlfy83l951aqwhumoel6r',
  },
  source: {
    couriers: 'couriers',
    venues: 'venues',
  },
  layer: {
    couriers: 'couriers',
    venues: 'venues',
    venuesLabels: 'venues-labels',
    clusters: 'clusters',
    venuesClusters: 'venues-clusters',
    venuesClustersCount: 'venues-clusters-count',
  },
};

export const ZIndex = {
  Map: 0,
  Sidebar: 10,
  Header: 11,
  CourierDetails: 12,
  CourierSidePanel: 1,
} as const;

export type ZIndex = (typeof ZIndex)[keyof typeof ZIndex];

export const SECOND_IN_MS = 1000;
export const MINUTE_IN_MS = 60 * SECOND_IN_MS;
export const MINUTE_IN_SECONDS = 60;

export const HOUR_IN_MINUTE = 60;
export const DAY_IN_SECONDS = 24 * HOUR_IN_MINUTE * MINUTE_IN_SECONDS;

export const COUNTRY_CODE = {
  AZERBAIJIAN: CountryCodeAlpha3.parse('AZE'),
  CROATIA: CountryCodeAlpha3.parse('HRV'),
  CYPRUS: CountryCodeAlpha3.parse('CYP'),
  FINLAND: CountryCodeAlpha3.parse('FIN'),
  GEORGIA: CountryCodeAlpha3.parse('GEO'),
  GERMANY: CountryCodeAlpha3.parse('DEU'),
  GREECE: CountryCodeAlpha3.parse('GRC'),
  HUNGARY: CountryCodeAlpha3.parse('HUN'),
  JAPAN: CountryCodeAlpha3.parse('JPN'),
  KAZAKHSTAN: CountryCodeAlpha3.parse('KAZ'),
  MALTA: CountryCodeAlpha3.parse('MLT'),
  NORTH_MACEDONIA: CountryCodeAlpha3.parse('MKD'),
  POLAND: CountryCodeAlpha3.parse('POL'),
  ROMANIA: CountryCodeAlpha3.parse('ROU'),
  SERBIA: CountryCodeAlpha3.parse('SRB'),
  SLOVAKIA: CountryCodeAlpha3.parse('SVK'),
  SWEDEN: CountryCodeAlpha3.parse('SWE'),
  UNITED_STATES_OF_AMERICA: CountryCodeAlpha3.parse('USA'),
  LUXEMBOURG: CountryCodeAlpha3.parse('LUX'),
  CZECHIA: CountryCodeAlpha3.parse('CZE'),
  NORWAY: CountryCodeAlpha3.parse('NOR'),
};

export const GEOLOCATION_HISTORY_SEARCH_PARAM_DATE = 'date';
export const ISO_DATE_FORMAT = 'yyyy-MM-dd'; // 2024-05-22
export const MINUTES_IN_A_DAY = 24 * 60;
export const DATE_HEADER_FORMAT = 'EEE, do MMM';

// https://help.doordash.com/dashers/s/article/Requirements-for-Dashing?language=en_US
// 1. only applies to Dashers in the United States and Canada
// 2. Some state requires 19 years old
export const MIN_DASHER_AGE = 18;
export const MAX_DASHER_AGE = 200; // randomly picked

export const MIDNIGHT_BLUE_TOKEN = {
  COLOR: {
    BG_POPUP: '#1D2238',
    BG: '#161929',
    HOVER: 'rgba(255, 255, 255, 0.10)',
    ACTIVE: 'rgba(255, 255, 255, 0.15)',
  },
};

export const VIKA_EMAIL_ADDRESS = 'vika.petrova@wolt.com';

export const MONDAY: Day = 1;
export const SUNDAY: Day = 0;
